/**
 * <quantity-input> — increment/decrement buttons + bounded number input.
 * On change, dispatches a "qty:change" event with the new value.
 */
class QuantityInput extends globalThis.ThemeElement {
  connectedCallback() {
    this.input = this.$('input[type="number"]');
    this.dec = this.$('[data-qty-decrement]');
    this.inc = this.$('[data-qty-increment]');
    if (!this.input) return;
    this.on(this.dec, 'click', () => this.adjust(-1));
    this.on(this.inc, 'click', () => this.adjust(1));
    this.on(this.input, 'change', () => this.clamp());
    this.clamp();
  }
  adjust(delta) {
    const v = parseInt(this.input.value, 10) || 0;
    this.input.value = v + delta;
    this.clamp();
  }
  clamp() {
    let v = parseInt(this.input.value, 10) || 1;
    const min = parseInt(this.input.min, 10) || 1;
    const max = parseInt(this.input.max, 10) || 99;
    if (v < min) v = min;
    if (v > max) v = max;
    this.input.value = v;
    this.dec.disabled = v <= min;
    this.inc.disabled = v >= max;
    this.emit('qty:change', { value: v });
  }
}
if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
